<script lang="ts" setup>
import { useGetRouteQuery } from '~/common/function/url'

const isWebview = useGetRouteQuery('webview', '0')
</script>

<template>
  <ContentDoc>
    <template #not-found>
      <div class="flex items-center justify-center flex-col mt-20">
        <h1 class="text-10 font-bold">
          404
        </h1>
        <p>未找到相关文档</p>
      </div>
    </template>
    <template #default="{ doc }">
      <layout-nav-default-back :title="doc.title" :hidden-title="String(isWebview) === '1'" />
      <div class="max-w-200 m-auto p-lg markdown px-3 md:px-0">
        <ContentRenderer :value="doc" />
      </div>
    </template>
  </ContentDoc>
</template>

<style lang="scss">
.markdown {
  h1 {
    --uno: text-2xl font-bold mb-lg;
  }

  h2 {
    --uno: text-xl font-bold mb-lg;
  }

  h3 {
    --uno: text-lg font-bold mb-3;
  }

  h4,
  h5 {
    --uno: text-4 font-bold mb-3;
  }

  p {
    --uno: text-4  mb-3;
  }

  a {
    --uno: text-md text-blue-5 underline;
  }
}
</style>
